import React, { FC, useContext, useEffect } from "react";
import domtoimage from 'dom-to-image'
import { BoardContext, CardContext, SocketContext, TeamContext, UserContext } from "../../../../context";

import { CardSlot, PinkNotification, StrengthCard } from "../../../atoms";
import { ICard } from "../../../../interfaces"
import { CardType, Phase } from "../../../../util/enums";
import { useSound } from "../../../../hooks";
import { useTranslation } from "react-i18next";

interface IRenderStrengthCardType {
    fullScreen?: boolean;
}

const RenderStrengthCardType: FC<IRenderStrengthCardType> = ({fullScreen}) => {
    const { t } = useTranslation();
    const { chooseOneOfProposedCardsSocketEvent } = useContext(SocketContext);
    const { dataOfDoubleClickedSolutionCard } = useContext(CardContext)
    const { emailOfSelectedPlayerBoard } = useContext(UserContext);
    const { game } = useContext(TeamContext);
    const { saveStrengthImagesSocketEvent } = useContext(SocketContext);
    const { instructionTutorial } = useContext(BoardContext);

    let numberOfStrenghtCards = 5;
    const {playSound} = useSound();

    let fetchedStrenghtsCards: any[] = [];

    let strenghtsCards: ICard[] = [];

    if (!fullScreen) {
        fetchedStrenghtsCards = game?.gameInfo.players[emailOfSelectedPlayerBoard || ""]?.currentStrengthCards;
        
        if (fetchedStrenghtsCards)
        strenghtsCards = fetchedStrenghtsCards.map( (item: any) => {
            return {
                "id": item._id,
                "info": item.information,
                "description": item.description,
                "type": CardType.STRENGTH,
                "backImagePath": "https://printbymagic.com/wp-content/uploads/2014/08/BLUE-RED-BACK-VERTICAL.jpg"
            };
        })
    }


    if (fullScreen) {
        fetchedStrenghtsCards = game?.gameInfo.players[game?.gameInfo.currentPlayerEmail || ""].currentStrengthCards;

        strenghtsCards = fetchedStrenghtsCards.map( (item: any) => {
            return {
                "id": item._id,
                "info": item.information,
                "description": item.description,
                "type": CardType.STRENGTH,
                "backImagePath": "https://printbymagic.com/wp-content/uploads/2014/08/BLUE-RED-BACK-VERTICAL.jpg",
            };
        })
    }

    useEffect(() => {
        for (let i = 1; i <= numberOfStrenghtCards; i++) {
            let node = document.getElementById('strength_card_' + i);
            let id: any = 0;

            if (!node) continue;

            if (strenghtsCards[i])
                id = strenghtsCards[i].id;

            domtoimage.toPng(node)
                .then(function (dataUrl) {
                    let img = new Image();
                    img.src = dataUrl;
                    saveStrengthImagesSocketEvent(id, img.src);
                })
                .catch(function (error) {
                    console.error(error);
                });
        }
    }, [numberOfStrenghtCards, saveStrengthImagesSocketEvent, strenghtsCards]);

    const chooseOneOfProposedCardsByClickingOnStrengths = (strength_card_id: number | string | undefined) => {
        if(!strength_card_id) return;
        if(!dataOfDoubleClickedSolutionCard) return;

        if (game?.phase === Phase.CHOOSE_SOLUTION) {
            let img = new Image();
            chooseOneOfProposedCardsSocketEvent(strength_card_id, dataOfDoubleClickedSolutionCard.player.email, img.src);
        }
    }

    const renderStrenght = () => {
        return strenghtsCards.map((str_card: ICard, index: number) => {
            return (
                <div className="strength_card_game_left_side_wrapper" key={index} onDoubleClick={() => chooseOneOfProposedCardsByClickingOnStrengths(str_card.id)} onMouseEnter={() => playSound("/sounds/ItemHover.mp3")}>
                    {instructionTutorial === "leftSideOfTheScreen" && index === 2 &&
                        <PinkNotification notificationWidthVW={30} notificationRenderingSide="right" text={t("tipTheseAreYourFiveStrengthCardsThatYouChoseText")} moveFromTop={0} progressNumber={6} /> 
                    }
                    <CardSlot card={str_card} />
                </div>
            );
        });
    }

    const renderStrenghtsFullScreen = () => {
        return strenghtsCards.map((str_card: ICard, index: number) => {
            return (
                <div className="hover_increase_zindex" style={{position: "relative", width: "26.6vh", height: "35"}}  key={index} onDoubleClick={() => chooseOneOfProposedCardsByClickingOnStrengths(str_card.id)} onMouseEnter={() => playSound("/sounds/ItemHover.mp3")}>
                    <StrengthCard cardData={str_card} isFullScreenOn={true} strengthCardIndex={index} />
                </div>
            );
        });
    }


    return (
        <React.Fragment>
            {fullScreen ? renderStrenghtsFullScreen() : renderStrenght()}
        </React.Fragment>
    );
}

export default RenderStrengthCardType;